export default __webpack_public_path__ + "static/media/purchase_order_page.bc02a313.png";